import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Moment from 'moment';
import classes from './Chat.module.css';
import defaultAvatar from '../assests/user-profile/default-avatar.png'
import SendIcon from '../assests/UI/send.png'
import { onKeyDown } from "../service";
import UserProfile from "./UserProfile";
import * as SubmissionStatus from "../models/SubmissionStatus";


const Chat = ({ submissionDetails, dropClass, sendMessage, communication, newMessage, setNewMessage }) => {

    const { texts, direction } = useSelector(state => state.translate);
    const { user } = useSelector(state => state.auth);

    const divRef = useRef(null);

    useEffect(() => {
        // Scroll to the bottom of the div when the component mounts or updates
        divRef.current.scrollTop = divRef.current.scrollHeight;
      }, [communication]);

    const handleChange = (e) => {
        setNewMessage(e.target.value);
        e.target.style.height = `${e.target.scrollHeight + 2}px`;
    }

    return (
        <div className={`${classes.CommunicationStudentAllContainer} ${dropClass}`}>
            <div className={classes.CommunicationStudentContainer}>
                <div className={classes.CommunicationStudentBg}>
                    <div className={`${classes[direction]} ${classes.CommunicationStudentWrapper}`}
                        ref={divRef}
                        style={submissionDetails?.submissionStatusId == SubmissionStatus.notStarted || submissionDetails?.submissionStatusId == SubmissionStatus.started ? {} : { maxHeight: 'calc(100% - 165px)', minHeight: 'calc(100% - 165px)' }}>
                        <div className={classes.CommunicationStudent}>
                            {communication?.map((message, index) => {
                                return <div className={message.sourceObjectId === user.id ? classes.MyDetailsContainer : classes.DetailsContainer} key={index}>
                                    {index && communication[index - 1].sourceObjectId === message.sourceObjectId ? <div style={{ width: '48px' }}></div> :
                                        <UserProfile width="48px"
                                            image={message.sourceObjectId !== user.id ?
                                                `${message.sourceObjectProfileImage}` :
                                                user.profileImage ?
                                                    `${user.profileImage}` :
                                                    defaultAvatar}
                                        />}
                                    <div className={classes.MessageContent}>
                                        <div className={message.sourceObjectId === user.id ? classes.MyDateTime : classes.DateTime}>{Moment(message.sentDate).format('hh:mm DD.M.YY')}</div>
                                        {message?.contents && <p className={message.sourceObjectId === user.id ? classes.MyText : classes.Text}>{message.contents.text}</p>}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className={classes.SendMessage}>
                        <div className={classes.GrowingTextareaContainer}>
                            <textarea
                                className={classes.SingleRowTextarea}
                                placeholder={texts.writeSomething}
                                onChange={handleChange}
                                value={newMessage}
                            />
                        </div>
                        <img src={SendIcon} onClick={sendMessage} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, sendMessage)} />
                    </div>

                </div>
            </div>
        </div >
    )
}

export default Chat;
